import { render, staticRenderFns } from "./PDisplayCustomsClearance.vue?vue&type=template&id=0d4626d1"
import script from "./PDisplayCustomsClearance.vue?vue&type=script&lang=js"
export * from "./PDisplayCustomsClearance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports